<template>
  <div class="cameraDetail">
    <Modal
      title="预览文件"
      v-model="modalView"
      @on-visible-change="changeVisible"
      :mask-closable="false"
      width="750"
      fullscreen
      footer-hide
      class="preview-file"
    >
      <template  v-if="suffix == 'pdf'">
        <pdf v-for="item in numPages" :key="item" :src="url" :page="item" ref="pdf"></pdf>
      </template>
      <div v-else v-html="fileData"></div>
      <Spin fix v-if="spinLoading"></Spin>
    </Modal>
  </div>
</template>

<script>
import { fileView } from "@/api/public";

import pdf from "vue-pdf"
export default {
  name: "",
  components: { pdf },
  props: {
    url: String,
  },
  data() {
    return {
      modalView: false,
      fileData: "",
      spinLoading: false,
      suffix: "",
      numPages: null
    };
  },
  created() {
    this.modalView = true;
    this.suffix = _Util.matchFileSuffixType(this.url);
    if(this.suffix == "pdf") {
      this.getNumPages();
    } else {
      this.seeFile();
    }
  },
  mounted() {},
  methods: {
    getNumPages() {
      this.spinLoading = true;
      let loadingTask = pdf.createLoadingTask(this.url);
      loadingTask.promise.then(pdf => {
        this.numPages = pdf.numPages;
        this.spinLoading = false;
      }).catch(err => {
        console.error('pdf 加载失败', err);
        this.spinLoading = false;
      })
    },
    seeFile() {
      this.spinLoading = true;
      fileView({ filePath: this.url })
        .then((res) => {
          console.log(res, "res---文件预览");
          this.spinLoading = false;
          this.showFile = true;
          this.fileData = JSON.parse(JSON.stringify(res.data));
        })
        .catch((err) => {
          this.spinLoading = false;
        });
    },
    changeVisible(val) {
      this.modalView = false;
      if (!val) {
        this.$emit("close");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.preview-file{
  ::v-deep .ivu-modal-body {
      max-height: calc(100vh - 60px);
      padding: 24px !important;
  }
}
</style>
